<template>
  <v-app class="mx-auto mt-8" style="background: linear-gradient(135deg, #e0f7fa, #ffffff)">
    <v-container fluid class="d-flex justify-center">
      <v-card
        elevation="0"
        class="rounded-lg pa-6"
        style="min-width: 80vw; background: transparent"
      >
        <!-- 1. 日期選擇 -->
        <v-row dense class="my-4" align="center">
          <v-col cols="12" md="3">
            <div>
              <v-row dense no-gutters class="flex-nowrap">
                <v-col class="flex-grow-0">
                  <v-btn
                    tile
                    color="#BB2525"
                    class="white--text"
                    @click="changeDate(-1)"
                    elevation="0"
                    style="border-radius: 0; min-width: 40px"
                  >
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                </v-col>
                <v-col class="flex-grow-1">
                  <v-btn
                    tile
                    color="#BB2525"
                    class="white--text"
                    @click="menu = !menu"
                    elevation="0"
                    style="border-radius: 0; width: 100%"
                  >
                    {{ selectedDate }}
                  </v-btn>
                  <v-menu ref="menu" v-model="menu" :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <div v-on="on"></div>
                    </template>
                    <v-date-picker
                      v-model="selectedDate"
                      @input="menu = false"
                      color="#BB2525"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="flex-grow-0">
                  <v-btn
                    tile
                    color="#BB2525"
                    class="white--text"
                    @click="changeDate(1)"
                    elevation="0"
                    style="border-radius: 0; min-width: 40px"
                  >
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-spacer />
          <v-col cols="12" md="3">
            <v-btn
              color="primary"
              class="white--text"
              @click="exportReport"
              :loading="exporting"
              block
            >
              <v-icon left>mdi-file-export</v-icon>
              匯出預約表單
            </v-btn>
          </v-col>
        </v-row>

        <v-row dense>
          <!-- 2. 外出事件卡片 -->
          <v-col cols="12" md="6">
            <v-card
              elevation="4"
              color="cyan lighten-5"
              class="rounded-lg mb-6"
              height="100%"
              min-height="300"
            >
              <v-card-title class="headline font-weight-bold primary--text">
                <v-icon left>mdi-run</v-icon> 外出
              </v-card-title>
              <v-card-text class="pa-2">
                <v-row v-for="res in outings" :key="res.id" class="ma-1">
                  <v-col class="pa-1">
                    <v-chip
                      class="text-subtitle-1 font-weight-bold"
                      :color="getOutingStatusColor(res)"
                      text-color="black"
                      outlined
                      @click="openDialog(res)"
                    >
                      <v-icon left small>{{ getOutingStatusIcon(res) }}</v-icon>
                      {{ res.elderName }} ｜ {{ formatOutingDateTime(res) }}
                      <v-chip
                        small
                        :color="getStatusChipColor(res)"
                        text-color="white"
                        class="ml-2"
                      >
                        {{ getOutingStatus(res) }}
                      </v-chip>
                    </v-chip>
                  </v-col>
                </v-row>
                <div v-if="outings.length === 0" class="mx-2 text-subtitle-2 grey--text">
                  本日無外出預約
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- 2. 訪視事件卡片 -->
          <v-col cols="12" md="6">
            <v-card
              elevation="4"
              color="pink lighten-5"
              class="rounded-lg mb-6"
              height="100%"
              min-height="300"
            >
              <v-card-title class="headline font-weight-bold primary--text">
                <v-icon left>mdi-account-heart</v-icon> 訪視
              </v-card-title>
              <v-card-text class="pa-2">
                <div class="d-flex flex-wrap">
                  <v-chip
                    v-for="res in visits"
                    :key="res.id"
                    class="ma-1 text-subtitle-1 font-weight-bold"
                    color="pink lighten-1"
                    text-color="black"
                    outlined
                    @click="openDialog(res)"
                  >
                    {{ res.elderName }} ｜ {{ res.time }}
                  </v-chip>
                </div>
                <div v-if="visits.length === 0" class="mx-2 text-subtitle-2 grey--text">
                  本日無訪視預約
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card>

      <!-- 3. 編輯／刪除對話框 -->
      <v-dialog v-model="dialog" max-width="600px">
        <v-card elevation="2" class="rounded-lg">
          <v-card-title class="headline font-weight-bold">預約詳情</v-card-title>
          <v-card-text>
            <v-form ref="editForm" v-model="valid" lazy-validation>
              <!-- 長輩姓名 -->
              <v-text-field
                v-model="current.elderName"
                label="長輩姓名"
                outlined
                dense
                color="teal"
                :rules="[(v) => !!v || '此欄位必填']"
                required
              ></v-text-field>

              <!-- 事件類型 -->
              <v-select
                v-model="current.eventType"
                :items="['外出', '訪視']"
                label="事件"
                outlined
                dense
                color="teal"
                @change="onEventTypeChange"
                :rules="[(v) => !!v || '請選擇事件']"
                required
              ></v-select>

              <!-- 如果是「外出」，顯示：預計外出日期、預計外出時間、預計回歸日期、預計回歸時間 -->
              <template v-if="current.eventType === '外出'">
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-menu
                      v-model="editDepartureDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="current.departureDate"
                          label="預計外出日期"
                          prepend-icon="mdi-calendar"
                          readonly
                          outlined
                          dense
                          color="teal"
                          :rules="[(v) => !!v || '此欄位必填']"
                          required
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="current.departureDate"
                        locale="zh-TW"
                        :min="minDate"
                        @input="
                          editDepartureDateMenu = false
                          updateCurrentReturnMinDate()
                        "
                        color="teal"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="current.departureTime"
                      label="預計外出時間"
                      type="time"
                      outlined
                      dense
                      color="teal"
                      :rules="[(v) => !!v || '此欄位必填']"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense v-if="current.departureDate && current.departureTime">
                  <v-col cols="12" sm="6">
                    <v-menu
                      v-model="editReturnDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="current.returnDate"
                          label="預計回歸日期"
                          prepend-icon="mdi-calendar"
                          readonly
                          outlined
                          dense
                          color="teal"
                          :rules="[(v) => !!v || '此欄位必填']"
                          required
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="current.returnDate"
                        locale="zh-TW"
                        :min="currentReturnMinDate"
                        @input="editReturnDateMenu = false"
                        color="teal"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="current.returnTime"
                      label="預計回歸時間"
                      type="time"
                      outlined
                      dense
                      color="teal"
                      :rules="[(v) => !!v || '此欄位必填']"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </template>

              <!-- 如果是「訪視」，顯示：預約日期、預約時間 -->
              <template v-else-if="current.eventType === '訪視'">
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-menu
                      v-model="editDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="current.date"
                          label="預約日期"
                          prepend-icon="mdi-calendar"
                          readonly
                          outlined
                          dense
                          color="teal"
                          :rules="[(v) => !!v || '此欄位必填']"
                          required
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="current.date"
                        locale="zh-TW"
                        :min="minDate"
                        @input="
                          editDateMenu = false
                          onDateChange()
                        "
                        color="teal"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="current.time"
                      :items="availableTimeSlots.length > 0 ? availableTimeSlots : timeOptions"
                      label="預約時間"
                      outlined
                      dense
                      color="teal"
                      :rules="[(v) => !!v || '此欄位必填']"
                      required
                    ></v-select>
                  </v-col>
                </v-row>
              </template>

              <!-- 主要探訪者 & 主要電話 -->
              <v-row dense>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="current.primaryVisitor"
                    label="主要探訪者"
                    outlined
                    dense
                    color="teal"
                    :rules="[(v) => !!v || '此欄位必填']"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="current.primaryPhone"
                    label="主要聯絡電話"
                    outlined
                    dense
                    color="teal"
                    :rules="[
                      (v) => !!v || '此欄位必填',
                      (v) => /^[0-9]{10}$/.test(v) || '請輸入有效的 10 碼手機號',
                    ]"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- 次要探訪者 1 & 次要聯絡電話 1 -->
              <v-row dense>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="current.secondaryVisitor"
                    label="次要探訪者 1"
                    outlined
                    dense
                    color="teal"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="current.secondaryPhone"
                    label="次要聯絡電話 1"
                    outlined
                    dense
                    color="teal"
                    :rules="[
                      (v) => v === '' || /^[0-9]{10}$/.test(v) || '請輸入有效的 10 碼手機號',
                    ]"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- 次要探訪者 2 & 次要聯絡電話 2 -->
              <v-row dense>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="current.secondaryVisitor2"
                    label="次要探訪者 2"
                    outlined
                    dense
                    color="teal"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="current.secondaryPhone2"
                    label="次要聯絡電話 2"
                    outlined
                    dense
                    color="teal"
                    :rules="[
                      (v) => v === '' || /^[0-9]{10}$/.test(v) || '請輸入有效的 10 碼手機號',
                    ]"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- 提醒：以下欄位內容將被使用者端看到 -->
              <v-alert type="info" dense text class="mb-4">
                備註欄位內容將被家屬看到，請注意填寫！
              </v-alert>
              <v-textarea
                v-model="current.remarks"
                label="備註"
                auto-grow
                outlined
                dense
                color="teal"
              ></v-textarea>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-space-between">
            <v-btn text @click="dialog = false">取消</v-btn>
            <v-btn color="primary" text :disabled="!valid" @click="saveEdit">儲存</v-btn>
            <v-btn color="red" text @click="deleteReservation">刪除</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-app>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import qs from 'qs'

export default {
  data() {
    return {
      menu: false,
      dialog: false,
      valid: true,
      editDateMenu: false,
      editDepartureDateMenu: false,
      editReturnDateMenu: false,
      selectedDate: new Date().toISOString().substr(0, 10),
      visitReservations: [], // 訪視預約
      outingReservations: [], // 外出預約
      current: {},
      currentReturnMinDate: '',
      loading: false,
      error: null,
      exporting: false,
      availableTimeSlots: [], // 可用時段
      timeOptions: [
        '09:00',
        '09:30',
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '12:00',
        '12:30',
        '13:00',
        '13:30',
        '14:00',
        '14:30',
        '15:00',
        '15:30',
        '16:00',
        '16:30',
      ],
    }
  },
  computed: {
    outings() {
      return this.outingReservations.filter((r) => {
        const selectedDate = new Date(this.selectedDate)
        const departureDate = new Date(r.departureDate)
        const returnDate = new Date(r.returnDate)

        selectedDate.setHours(0, 0, 0, 0)
        departureDate.setHours(0, 0, 0, 0)
        returnDate.setHours(0, 0, 0, 0)

        return selectedDate >= departureDate && selectedDate <= returnDate
      })
    },
    visits() {
      return this.visitReservations.filter((r) => r.date === this.selectedDate)
    },
    minDate() {
      const d = new Date()
      return d.toISOString().substr(0, 10)
    },
  },
  methods: {
    async fetchVisitReservations(date) {
      try {
        this.loading = true
        this.error = null
        const response = await axios.get(`/api/standalone_reservation/visit/${date}/`)

        if (response.data.status === 'success') {
          this.visitReservations = response.data.data.map((item) => {
            const dateTime = new Date(item.data_time)
            const hours = dateTime.getHours().toString().padStart(2, '0')
            const minutes = dateTime.getMinutes()
            const adjustedMinutes = minutes < 30 ? '00' : '30'
            const formattedTime = `${hours}:${adjustedMinutes}`

            return {
              id: item.id,
              elderName: item.case_name,
              eventType: '訪視',
              date: dateTime.toISOString().split('T')[0],
              time: formattedTime,
              primaryVisitor: item.main_visitor,
              primaryPhone: item.main_visitor_phone,
              secondaryVisitor: item.sub_visitor_1 || '',
              secondaryPhone: item.sub_visitor_1_phone || '',
              secondaryVisitor2: item.sub_visitor_2 || '',
              secondaryPhone2: item.sub_visitor_2_phone || '',
              remarks: item.note || '',
            }
          })
        }
      } catch (error) {
        console.error('取得訪視預約資料失敗:', error)
        this.error = '取得訪視預約資料失敗'
      } finally {
        this.loading = false
      }
    },

    async fetchAvailableTimeSlots(date) {
      try {
        const response = await axios.get(
          `/api/standalone_reservation/check_time_slot/?date_str=${date}`
        )

        if (response.data.status === 'success') {
          this.availableTimeSlots = response.data.data
            .filter((slot) => slot.is_available)
            .map((slot) => slot.slot)
        } else {
          this.availableTimeSlots = []
        }
      } catch (error) {
        console.error('取得可用時段失敗:', error)
        this.availableTimeSlots = []
      }
    },

    async fetchOutingReservations(date) {
      try {
        this.loading = true
        this.error = null

        let response
        try {
          response = await axios.get(`/api/standalone_reservation/case_outings/${date}/`)
        } catch (error) {
          console.log('查詢失敗:', error)
        }

        if (response.data.status === 'success') {
          this.outingReservations = response.data.data.map((item) => {
            const startDateTime = new Date(item.start_time)
            const endDateTime = new Date(item.end_time)
            return {
              id: item.id,
              elderName: item.case_name,
              eventType: '外出',
              departureDate: startDateTime.toISOString().split('T')[0],
              departureTime: startDateTime.toLocaleTimeString('zh-TW', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
              }),
              returnDate: endDateTime.toISOString().split('T')[0],
              returnTime: endDateTime.toLocaleTimeString('zh-TW', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
              }),
              primaryVisitor: item.main_visitor,
              primaryPhone: item.main_visitor_phone,
              secondaryVisitor: item.sub_visitor_1 || '',
              secondaryPhone: item.sub_visitor_1_phone || '',
              secondaryVisitor2: item.sub_visitor_2 || '',
              secondaryPhone2: item.sub_visitor_2_phone || '',
              remarks: item.note || '',
            }
          })
        }
      } catch (error) {
        console.error('取得外出預約資料失敗:', error)
        this.error = '取得外出預約資料失敗'
      } finally {
        this.loading = false
      }
    },

    async openDialog(res) {
      this.current = { ...res }
      if (this.current.departureDate) {
        this.currentReturnMinDate = this.current.departureDate || this.minDate
      }

      // 如果是訪視，取得可用時段
      if (this.current.eventType === '訪視') {
        await this.fetchAvailableTimeSlots(this.current.date || this.selectedDate)
      }

      this.dialog = true
    },
    async onEventTypeChange(val) {
      if (val === '外出') {
        this.current.date = ''
        this.current.time = ''
        this.current.departureDate = this.current.departureDate || this.minDate
        this.current.departureTime = this.current.departureTime || '08:00'
        this.current.returnDate = this.current.returnDate || this.current.departureDate
        this.current.returnTime = this.current.returnTime || '09:00'
      } else if (val === '訪視') {
        this.current.departureDate = ''
        this.current.departureTime = ''
        this.current.returnDate = ''
        this.current.returnTime = ''
        this.current.date = this.current.date || this.minDate
        this.current.time = this.current.time || '08:00'

        // 取得可用時段
        await this.fetchAvailableTimeSlots(this.current.date)
      }
    },
    updateCurrentReturnMinDate() {
      this.currentReturnMinDate = this.current.departureDate || this.minDate
      if (this.current.returnDate < this.currentReturnMinDate) {
        this.current.returnDate = this.currentReturnMinDate
      }
    },

    async onDateChange() {
      if (this.current.eventType === '訪視' && this.current.date) {
        await this.fetchAvailableTimeSlots(this.current.date)
        if (this.current.time && !this.availableTimeSlots.includes(this.current.time)) {
          this.current.time = ''
        }
      }
    },
    async saveEdit() {
      try {
        if (this.current.departureDate) {
          const idx = this.outingReservations.findIndex((r) => r.id === this.current.id)
          if (idx !== -1) {
            const data = {
              start_time: moment(
                `${this.current.departureDate} ${this.current.departureTime}`
              ).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
              end_time: moment(`${this.current.returnDate} ${this.current.returnTime}`).format(
                'YYYY-MM-DDTHH:mm:ss.SSSZ'
              ),
              case_name: this.current.elderName,
              main_visitor: this.current.primaryVisitor,
              main_visitor_phone: this.current.primaryPhone,
              sub_visitor_1: this.current.secondaryVisitor || '',
              sub_visitor_1_phone: this.current.secondaryPhone || '',
              sub_visitor_2: this.current.secondaryVisitor2 || '',
              sub_visitor_2_phone: this.current.secondaryPhone2 || '',
              note: this.current.remarks || '',
            }

            const response = await axios.post(
              `/api/standalone_reservation/case_outings/${this.current.id}/edit/`,
              qs.stringify(data),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
              }
            )

            if (response.status === 200) {
              this.dialog = false
              await this.fetchOutingReservations(this.selectedDate)
            } else {
              throw new Error('更新失敗')
            }
          }
        } else {
          const idx = this.visitReservations.findIndex((r) => r.id === this.current.id)
          if (idx !== -1) {
            const data = {
              data_time: moment(`${this.current.date} ${this.current.time}`).format(
                'YYYY-MM-DDTHH:mm:ssZ'
              ),
              main_visitor: this.current.primaryVisitor,
              main_visitor_phone: this.current.primaryPhone,
              case_name: this.current.elderName,
              sub_visitor_1: this.current.secondaryVisitor || '',
              sub_visitor_1_phone: this.current.secondaryPhone || '',
              sub_visitor_2: this.current.secondaryVisitor2 || '',
              sub_visitor_2_phone: this.current.secondaryPhone2 || '',
              note: this.current.remarks || '',
            }

            const response = await axios.post(
              `/api/standalone_reservation/visit/${this.current.id}/edit/`,
              qs.stringify(data),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
              }
            )

            if (response.status === 200) {
              this.dialog = false
              await this.fetchVisitReservations(this.selectedDate)
            } else {
              throw new Error('更新失敗')
            }
          }
        }
      } catch (error) {
        console.error('更新預約失敗:', error)
        this.error = '更新預約失敗：' + (error.message || '未知錯誤')
      }
    },
    async deleteReservation() {
      try {
        const data = {
          delete_word: '刪除',
        }

        if (this.current.departureDate) {
          const response = await axios.post(
            `/api/standalone_reservation/case_outings/${this.current.id}/delete/`,
            qs.stringify(data),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
            }
          )

          if (response.status === 204) {
            this.dialog = false
            await this.fetchOutingReservations(this.selectedDate)
          } else {
            throw new Error('刪除失敗')
          }
        } else {
          const response = await axios.post(
            `/api/standalone_reservation/visit/${this.current.id}/delete/`,
            qs.stringify(data),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
            }
          )

          if (response.status === 204) {
            this.dialog = false
            await this.fetchVisitReservations(this.selectedDate)
          } else {
            throw new Error('刪除失敗')
          }
        }
      } catch (error) {
        console.error('刪除預約失敗:', error)
        this.error = '刪除預約失敗：' + (error.message || '未知錯誤')
      }
    },
    changeDate(days) {
      const currentDate = new Date(this.selectedDate)
      currentDate.setDate(currentDate.getDate() + days)
      this.selectedDate = currentDate.toISOString().split('T')[0]
    },
    formatOutingDateTime(res) {
      const startDate = new Date(`${res.departureDate}T${res.departureTime}`)
      const endDate = new Date(`${res.returnDate}T${res.returnTime}`)
      const selectedDate = new Date(this.selectedDate)

      const formatDate = (date) => {
        return date.toLocaleDateString('zh-TW', {
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        })
      }

      const isMultiDay = res.departureDate !== res.returnDate

      if (isMultiDay) {
        return `${formatDate(startDate)} - ${formatDate(endDate)}`
      } else {
        return `${res.departureTime} - ${res.returnTime}`
      }
    },

    getOutingStatusColor(res) {
      const status = this.getOutingStatus(res)
      switch (status) {
        case '出發日':
          return 'teal lighten-1'
        case '回歸日':
          return 'pink lighten-1'
        case '外出中':
          return 'cyan lighten-1'
        default:
          return 'teal lighten-1'
      }
    },
    getOutingStatusIcon(res) {
      const status = this.getOutingStatus(res)
      switch (status) {
        case '出發日':
          return 'mdi-run'
        case '回歸日':
          return 'mdi-home'
        case '外出中':
          return 'mdi-run'
        default:
          return 'mdi-run'
      }
    },
    getOutingStatus(res) {
      const selectedDate = new Date(this.selectedDate)
      const departureDate = new Date(res.departureDate)
      const returnDate = new Date(res.returnDate)

      selectedDate.setHours(0, 0, 0, 0)
      departureDate.setHours(0, 0, 0, 0)
      returnDate.setHours(0, 0, 0, 0)

      if (selectedDate.getTime() === departureDate.getTime()) {
        return '出發日'
      } else if (selectedDate.getTime() === returnDate.getTime()) {
        return '回歸日'
      } else {
        return '外出中'
      }
    },
    getStatusChipColor(res) {
      const status = this.getOutingStatus(res)
      switch (status) {
        case '出發日':
          return 'teal'
        case '回歸日':
          return 'pink'
        case '外出中':
          return 'cyan'
        default:
          return 'teal'
      }
    },
    async exportReport() {
      try {
        this.exporting = true
        const response = await axios.get(
          `/api/standalone_reservation/generate_report/?date=${this.selectedDate}`,
          {
            responseType: 'blob',
          }
        )

        // 建立下載連結
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `預約表單_${this.selectedDate}.docx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error('匯出預約表單失敗:', error)
        this.error = '匯出預約表單失敗：' + (error.message || '未知錯誤')
      } finally {
        this.exporting = false
      }
    },
  },
  watch: {
    selectedDate: {
      immediate: true,
      async handler(newDate) {
        await Promise.all([
          this.fetchVisitReservations(newDate),
          this.fetchOutingReservations(newDate),
        ])
      },
    },
  },
}
</script>

<style scoped>
.hover-scale {
  transition: transform 0.2s ease-in-out;
}
.hover-scale:hover {
  transform: scale(1.05);
}
</style>
